import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { fetchOperatorGroup, fetchSiteSettings } from '../core/actions';
import {
  selectAnalyticsEnabled,
  selectRole,
  selectUserGroupDynamicPermissions,
} from '../store/authReducer';
import { fetchReport, fetchVisualReport } from '../views/analytics/actions';
import { selectEmbedToken } from '../views/analytics/reducer';
import { setSelectedSite } from '../views/site-selection/actions';
import { SAFETY_INTERVAL } from '../views/analytics/sagas';
import { useAppContext } from '../providers/AppProvider';
import { useFeatureFlag } from '../core/hooks/useFeatureFlag';
import {
  ANALYTICS_RESTRUCTURE_FLAG,
  ANALYTICS_RESTRUCTURE_FLAG_DEFAULT,
} from '../views/analytics/models';
interface Props {
  children: React.ReactNode;
}

const SiteDispatcher = ({ children }: Props) => {
  const { site } = useParams<{ site: string }>();
  const dispatch = useDispatch();

  const analyticsEnabled = useSelector(selectAnalyticsEnabled);
  const isAdmin = useSelector(selectRole);
  const analyticsDynamicPermissions = useSelector(selectUserGroupDynamicPermissions);
  const history = useHistory();
  const { isWashClub } = useAppContext();
  const analyticsRestructureEnabled = useFeatureFlag(
    ANALYTICS_RESTRUCTURE_FLAG,
    ANALYTICS_RESTRUCTURE_FLAG_DEFAULT
  );
  const reportType = isWashClub ? 'Manager-Analytics-WashClub' : 'Manager-Analytics';
  const token = useSelector((state) => selectEmbedToken(state, reportType));

  // SiteDispatcher wraps the Switch rather than sitting inside a route, so switching
  // sites changes :site without remounting it. Anything scoped to the site in the URL
  // has to key off that param or it keeps describing the site we came from.
  useEffect(() => {
    if (!site) return;
    dispatch(setSelectedSite({ id: site }));
    dispatch(fetchSiteSettings(history, '/site-selection'));
  }, [site]);

  useEffect(() => {
    if (!token) {
      if (
        !analyticsRestructureEnabled &&
        (isAdmin ||
          analyticsEnabled ||
          (Array.isArray(analyticsDynamicPermissions) &&
            analyticsDynamicPermissions.some((permission) =>
              permission.ref.includes('analytics_tabs')
            )))
      ) {
        dispatch(fetchReport(SAFETY_INTERVAL, reportType, isWashClub));
        //Currently used for testing dashboard tiles
        //dispatch(fetchVisualReport(SAFETY_INTERVAL, 'Tile-Testing', true));
      }
    }
    // The operator group is scoped to the user, not the site, so it stays mount-only.
    dispatch(fetchOperatorGroup());
  }, []);

  return children;
};

export default SiteDispatcher;
